import React, { useState, useEffect, useMemo } from "react";
import {
  getAllAvivit,
  cleanAll,
  setBelogs,
  setDone,
} from "../../store/reducers/todosReducer";
import { toast } from "react-toastify";
import FilledLoading from "../common/loader/FilledLoading";
import OpacityLoading from "../common/loader/OpacityLoading";
import { useSelector, useDispatch } from "react-redux";
import ClientRoutes from "../../navigation/Routes";
import {
  FlexRowBetween,
  GenericDiv,
  ListHolder,
  RespFont,
  TextWithPic,
  TodoCard,
} from "../common/Style";
import ToolsOptions from "../user/ToolsOptions";
import GenericModal from "../common/modals/GenericModal";
import { useHistory } from "react-router-dom";
import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import tools from "../../assets/common/menu.svg";
import trash from "../../assets/common/trashB.svg";

import logout from "../../assets/common/logout.svg";
import sms from "../../assets/common/sms.svg";
import whatsapp from "../../assets/common/whatsapp.svg";
import refresh from "../../assets/common/refresh.svg";
import BottomMenu from "../common/others/BottomMenu";
import Switcher from "../common/switcher/Switcher";
import { days, exportToCSV } from "../common/others/Functions";
import {
  countNotAnswered,
  deleteNews,
  getNews,
  getPhoneNumber,
} from "../../store/reducers/dataReducer";
import CopyText from "../common/others/CopyText";
import { getAll, getAllGAvivit } from "../../store/reducers/guestsReducer";
import YesNoModal from "../common/modals/YesNoModal";

const News = () => {
  const [showDelete, setShowDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const { dataLoading } = useSelector((state) => state.dataReducer);
  let history = useHistory();
  const [showLogout, setShowLogout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [news, setNews] = useState({});

  const handleGetAll = () => {
    setShowLoading(true);
    dispatch(getNews()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else setNews(res.payload);
      setShowLoading(false);
    });
  };

  const handleDestroyUser = async () => {
    setLoading(true);
    dispatch(deleteNews(showDelete)).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else {
        toast.success("הפעולה בוצעה בהצלחה!");
        setShowDelete(false);
        handleGetAll();
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    handleGetAll();
    return () => {
      dispatch(cleanAll());
    };
  }, []);
  let todosArray = useMemo(() => {
    let today = new Date();
    let msg = "";
    let arr = [];
    let sortedArray = [];
    if (Object.keys(news).length > 0) {
      for (const [key, value] of Object.entries(news)) sortedArray.push(value);
      for (let i = 0; i < sortedArray.length; i++) {
        msg = `היי,
        מדברים מחברת *${sortedArray[i].producer}* - אישורי ההגעה שלכם!\n\nאנחנו רוצים שגם לכם וגם לנו יהיה תהליך נוח ונעים ולכן קודם כל נבקש שתעברו על מסמך תיאום הציפיות שהכנו, תאשרו שהכל מקובל ורק אז נצא לדרך 💪\n\nמסמך תיאום ציפיות - https://wedding-harmony-2587b071.base44.app/\n\nאחרי *שהסכמתם* על מסמך תיאום הציפיות בחרו האם תרצו לשלוח לנו הזמנה ואקסל עד חודש לפני האירוע ומשם אנחנו נוביל את התהליך או שאתם רוצים להיכנס לאתר ולהוסיף ישירות מאנשי הקשר ללא שימוש באקסל
        \nתבנית אקסל - https://l5k.me/Vzf2m
        \nפרטי התחברות:
        לינק לאתר - https://callup.ltd/
        מס׳ נייד - ${sortedArray[i].phone}
        סיסמא - ${sortedArray[i].password}`;
        arr.push(
          <TodoCard key={i}>
            <RespFont>{sortedArray[i].producer}</RespFont>
            <CopyText marginLeft={"5px"} dataToCopy={msg} text={"הודעה"} />
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me/972${sortedArray[i].phone}/?text=`}
            >
              <img src={whatsapp} alt={"whatsapp"} style={{ width: "31px" }} />
            </a>
            <img
              src={trash}
              alt="trash"
              style={{ width: "21px" }}
              onClick={() => setShowDelete(sortedArray[i]._id)}
            />
          </TodoCard>
        );
      }
    }
    return arr;
  }, [news]);

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      <BottomMenu
        data={[
          <img
            key={1}
            src={refresh}
            alt="refresh"
            style={{ width: "23px", padding: "10px 0", cursor: "pointer" }}
            onClick={handleGetAll}
          />,
          <img
            key={2}
            src={tools}
            alt="tools"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowMenu(true)}
          />,
          <img
            key={3}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />
      <ListHolder>{todosArray}</ListHolder>
      <div style={{ height: "100px" }} />

      {showLoading && <FilledLoading />}
      {dataLoading && <OpacityLoading />}
      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {showDelete && (
        <GenericModal
          init={setShowDelete}
          div={
            <YesNoModal
              title={"מחיקת משימה"}
              body={"האם את/ה בטוח/ה שברצונך למחוק משימה זו?"}
              no={setShowDelete}
              yes={handleDestroyUser}
            />
          }
        />
      )}

      {loading && <OpacityLoading />}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.Admin.main)}
                >
                  ראשי
                </TextWithPic>,
                // <TextWithPic
                //   onClick={() => history.push(ClientRoutes.Admin.todos)}
                //   key={2}
                // >
                //   משימות
                // </TextWithPic>,
              ]}
            />
          }
        />
      )}
    </div>
  );
};

export default News;
